const BaseView = require('./view').default;
const seatsPostBookingUtils = require('../../../utils/postbooking/js/seats');

module.exports = BaseView.extend({
    providerABs: {
        '1A': Odigeo.AB.isPostBookingSeatsSB3OF21AMobile,
        'TP': Odigeo.AB.isPostBookingSeatsSB3OF2TPMobile,
        'TF': Odigeo.AB.isPostBookingSeatsSB3OF2TFMobile,
    },
    shouldDisplayOF2Seats: (bookingInfo, providerABs) => {
        return Odigeo.AB.isPostBookingSeatsSB3OF2Mobile || seatsPostBookingUtils.areAllProvidersActiveOF2(bookingInfo, providerABs);
    },
});
